export default "/images/vendor/flag-icons/flags/1x1/bw.svg?3697157a23bdcf5b8c7aea538e231ef6";